import { container } from 'tsyringe';
import { OperationalApiRepository } from '../../repositories/api/OperationalAreaApiRepository';
import ApiService from '../../services/ApiService';
import { OperationalAreaMapper } from '@/data/persistences/mappers/OperationalAreaMapper';
import { OperationalAreaEndpoint } from '../../endpoints/OperationalAreaEndpoint';
import { OperationalAreaPresenter } from '@/app/ui/presenters/OperationalAreaPresenter';

export class OperationalAreaComponent {
  public static init() {
    container.register<OperationalApiRepository>(OperationalApiRepository, {
      useFactory: d => {
        return new OperationalApiRepository(
          d.resolve(ApiService),
          d.resolve(OperationalAreaMapper),
          d.resolve(OperationalAreaEndpoint)
        )
      }
    });
    container.register<OperationalAreaMapper>(OperationalAreaMapper, {
      useClass: OperationalAreaMapper
    });
    container.register(OperationalAreaPresenter, {
      useFactory: d => {
        return new OperationalAreaPresenter(d.resolve(OperationalApiRepository));
      }
    });
  }
}
